<template>
  <div>
    <div class="textCenter">
    <div ref="textDiv" style="display: none">您已登录图书馆系统，请在新打开页面查看</div>
    <a :href="loginUrl" target="_blank" ref="loginA" referrerpolicy="no-referrer">{{loginText}}</a>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';

  export default {
    name: "trainingManage",
    data() {
      return {
        loginUrl:"https://elib.cnki.net/Facade/FacadeLogin.aspx?action=login&p=https%3A//cpc.cnki.net/&ep=https%3A//cpc.cnki.net/&password=edx2018&username=edx2018",
        loginText:"登录"
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        this.login();
      });
    },
    methods: {
      login(){
        "正在登录图书馆".showMessage();
        let this_ = this;
        setTimeout(function () {
          this_.$refs.loginA.click();
          $(".flavr-container").hide();
          this_.loginText="重新登录"
          $(this_.$refs.textDiv).show();
        },2000)

      }
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .textCenter{
    text-align: center;
    padding: 25% 0;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/library.vue